import React from 'react';
import { ViewProps } from 'react-native';
import styled from 'styled-components/native';

const StyledView = styled.View<ListItemIconProps>`
  ${p =>
    p.iconPosition === 'left' ? 'margin-right: 12px;' : 'margin-left: 12px;'}
` as React.FC<ListItemIconProps>;

export type ListItemIconProps = ViewProps & {
  iconPosition?: 'left' | 'right';
};

const ListItemIcon: React.FC<ListItemIconProps> = ({
  iconPosition = 'left',
  children,
  ...props
}) => {
  return (
    <StyledView iconPosition={iconPosition} {...props}>
      {children}
    </StyledView>
  );
};

export default ListItemIcon;
